<div class="flex-fill d-flex flex-column card">
  <div class="card">
    <div class="card-body" style="max-width: 300px">
      <dx-form [formData]="filter" appAutofocusForm="partNumber" (onEditorEnterKey)="search()">
        <dxi-item dataField="startDate" editorType="dxDateBox"></dxi-item>
        <dxi-item dataField="endDate" editorType="dxDateBox"></dxi-item>
      </dx-form>
      <div class="btn-toolbar justify-content-end align-items-center mt-1">
        <button accesskey="s" (click)="search()" class="btn btn-primary">Search</button>
        <button (click)="clear()" class="btn btn-secondary ms-2">Clear</button>
      </div>
    </div>
  </div>
  <!-- Sales By Category -->
  <div class="d-flex flex-fill flex-row card p-1">
    <div class="col-sm-3 p-1">
      <dx-data-grid #categorySummariesGrid keyExpr="id" class="grid-fill flex-fill h-100" [dataSource]="categorySummaries">
        <dxi-column dataField="name"></dxi-column>
        <dxi-column dataField="taxedTotal" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
        <dxi-column dataField="total" [format]="{ type: 'currency', precision: 2 }"></dxi-column>

        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
        <dxo-state-storing [enabled]="true" type="localStorage" storageKey="category-summaries-grid"></dxo-state-storing>
        <div *dxTemplate="let data of 'toolbarButtons'"></div>
        <div *dxTemplate="let data of 'toolbarText'"></div>
      </dx-data-grid>
    </div>

    <!-- Sales By Product -->
    <div class="col-sm-4 p-1">
      <dx-data-grid #productSummariesGrid keyExpr="id" class="grid-fill flex-fill h-100" [dataSource]="productSummaries">
        <dxi-column dataField="partNumber" caption="Name"></dxi-column>
        <dxi-column dataField="description"></dxi-column>
        <dxi-column dataField="category"></dxi-column>
        <dxi-column dataField="total" [format]="{ type: 'fixedPoint', precision: 2 }"></dxi-column>
        <dxi-column dataField="totalPrice" [format]="{ type: 'currency', precision: 2 }"></dxi-column>

        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
        <dxo-state-storing [enabled]="true" type="localStorage" storageKey="product-summaries-grid"></dxo-state-storing>
        <div *dxTemplate="let data of 'toolbarButtons'"></div>
        <div *dxTemplate="let data of 'toolbarText'"></div>
      </dx-data-grid>
    </div>

    <div class="col-sm-5 p-1">
      <dx-data-grid #dailyCategorySummariesGrid keyExpr="day" class="grid-fill flex-fill h-100" [dataSource]="dailyCategorySummaries" [columns]="dailyCategorySummaryColumns">
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
        <dxo-state-storing [enabled]="true" type="localStorage" storageKey="daily-category-summaries-grid"></dxo-state-storing>
        <div *dxTemplate="let data of 'toolbarButtons'">
          @if (filter) {
            <div>
              <dx-select-box
                [(value)]="filter.month"
                [items]="months"
                displayExpr="name"
                valueExpr="value"
                width="80px"
                (onValueChanged)="getDailyCategorySummaries()"
              ></dx-select-box>
              <dx-select-box [(value)]="filter.year" [items]="years" width="80px" (onValueChanged)="getDailyCategorySummaries()"></dx-select-box>
            </div>
          }
        </div>
        <div *dxTemplate="let data of 'toolbarText'"></div>
      </dx-data-grid>
    </div>
  </div>
</div>
